import script from "./RecuperarContraseña.vue?vue&type=script&setup=true&lang=js"
export * from "./RecuperarContraseña.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=0e2fb1fa&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2fb1fa"]])

export default __exports__